/*
 * Palo Alto Theme - Custom JS
 * Add your custom Javascript here.
 * Make sure the custom.js file is uncommented in layout/theme.liquid
 */

(function () {
  document.addEventListener('DOMContentLoaded', function () {

    const burger = document.querySelector('.mobile-menu__button--burger');
    const mobileMenu = document.querySelector('.mobile-menu');
    const header = document.querySelector('header-component');

    if (!burger || !mobileMenu) return;

    // Toggle mobile menu
    burger.addEventListener('click', function () {
      mobileMenu.classList.toggle('is-open');
      burger.classList.toggle('is-active');

      if (header) {
        header.classList.toggle('site-header--compress');
      }
    });

    // Close menu when clicking outside
    document.addEventListener('click', function (e) {
      if (
        mobileMenu.classList.contains('is-open') &&
        !mobileMenu.contains(e.target) &&
        !burger.contains(e.target)
      ) {
        mobileMenu.classList.remove('is-open');
        burger.classList.remove('is-active');

        if (header) {
          header.classList.remove('site-header--compress');
        }
      }
    });

    // Optional: Ensure correct display on resize
    function handleResize() {
      if (window.innerWidth > 768) {
        mobileMenu.classList.remove('is-open');
        burger.classList.remove('is-active');
      }
    }

    window.addEventListener('resize', debounce(handleResize, 100));

    // Simple internal debounce fallback
    function debounce(func, wait) {
      let timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, wait);
      };
    }

  });
})();







document.addEventListener('DOMContentLoaded', function() {

  // Wait for header-component to initialize
  const waitForHeader = setInterval(function() {
    const header = document.querySelector('header-component');
    if (!header) return;
    clearInterval(waitForHeader);

    // Override the checkWidth method to only compress at 768px
    header.checkWidth = function() {
      if (this.isResizing) return;
      this.isResizing = true;

      const shouldCompress = window.innerWidth <= 768;
      const hasCompress = this.classList.contains('site-header--compress');

      if (shouldCompress && !hasCompress) {
        this.classList.add('site-header--compress');
      } else if (!shouldCompress && hasCompress) {
        this.classList.remove('site-header--compress');
      }

      this.isResizing = false;
    };

    // Run it immediately to correct current state
    header.checkWidth();

  }, 50);

});